export enum IndicatorType {
  BA = 'BA',
  TICADI_CALCULATED = 'TICADI_CALCULATED',
  TICADI_ASSOCIATION = 'TICADI_ASSOCIATION',
  TICADI_BA = 'TICADI_BA',
}
